var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMrvOutlineLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.716 2.235a.932.932 0 00-.603-.887.952.952 0 00-1.06.21L13.572 13.934l4.527 4.486c.228.225.352.526.352.845v3.486a1.44 1.44 0 01-1.445 1.432h-8.85v1.578c0 .53.433.962.969.962H26.75c.535 0 .97-.432.97-.962V2.235h-.004zM8.158 19.299l-.004 3.61h8.847a.16.16 0 00.16-.161v-3.453l-4.5-4.46L8.159 19.3zM6.87 22.913l.004-3.644c0-.32.123-.616.352-.842l4.53-4.49L3.16 5.414a1.067 1.067 0 00-.764-.323c-.142 0-.288.03-.434.086a1.056 1.056 0 00-.678 1.007v15.64c0 .602.494 1.09 1.097 1.09H6.87zM27.607.176A2.197 2.197 0 0129 2.238v23.527A2.247 2.247 0 0126.746 28H9.12a2.247 2.247 0 01-2.254-2.235v-1.578H2.381C1.071 24.183 0 23.123 0 21.823V6.183C0 5.21.565 4.373 1.471 4a2.36 2.36 0 012.595.511l8.596 8.525L25.152.66a2.233 2.233 0 012.455-.484z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMrvOutlineLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mrvOutlineLogo.c210dcf15979e2195c05717df262136f.svg";